<template>
  <div v-on-clickaway="handleDropDownClose">
    <button
      class="mr-3 btn tabdropdown-trigger"
      :style="{
        color: primary,
        'border-color': primary
      }"
      type="button"
      @click="handleDropDownToggleClick"
    >
      {{ buttonPlaceholder }}
    </button>
    <div class="tabdropdown-wrapper">
      <ul v-if="!isCalendar" :class="tabdropdownListClass">
        <template v-for="dropdownItem in dropdownItems">
          <li
            v-if="dropdownItem.disabled"
            :key="dropdownItem.value"
            class="tabdropdown-item tabdropdown-item__disabled"
          >
            {{ dropdownItem.name }}
          </li>
          <li
            v-else
            :key="dropdownItem.value"
            class="tabdropdown-item"
            @click="
              () =>
                handleTabDropDownItemClick(
                  dropdownItem.value,
                  dropdownItem.name
                )
            "
          >
            {{ dropdownItem.name }}
          </li>
        </template>
      </ul>
      <template v-else>
        <div
          :style="{
            position: position === 'relative' ? 'relative' : 'absolute'
          }"
          v-if="showCalendar"
          :class="
            showToTop ? 'calendar-wrapper show top' : 'calendar-wrapper show'
          "
        >
          <date-picker-local
            v-model="date"
            :local="local"
            :disabledDate="disabledDate"
            type="inline"
            @nm="nm"
            @pm="pm"
            @ny="ny"
            @py="py"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import DatePickerLocal from "@/components/datetimepicker/DatePickerLocal";
import moment from "@/helpers/moment";
import { dateUTC } from "@/helpers/date";
import _ from "lodash";
import { mixin as clickaway } from "vue-clickaway";

export default {
  mixins: [clickaway],
  name: "TabDropdown",
  components: {
    DatePickerLocal
  },
  props: {
    position: {
      type: String,
      default: "absolute"
    },
    isCalendar: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    dropdownItems: {
      type: Array,
      default: () => []
    },
    currentStep: {
      type: String,
      default: ""
    },
    stepCount: {
      type: Number,
      default: 1
    },
    showToTop: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Array, Object],
      default: null
    },
    disabledDate: {
      type: Function,
      default: () => {
        return false;
      }
    }
  },
  data() {
    return {
      buttonPlaceholder: this.placeholder,
      clicked: false,
      showDropDown: false,
      showCalendar: false,
      date: "",
      local: {
        dow: 0,
        hourTip: "Select Hour",
        minuteTip: "Select Minute",
        secondTip: "Select Second",
        yearSuffix: "",
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ),
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_")
      }
    };
  },
  computed: {
    tabdropdownListClass() {
      return (
        (this.showDropDown
          ? "tabdropdown-list block block-shadow show"
          : "tabdropdown-list block block-shadow") +
        (this.showToTop ? " top" : "")
      );
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    event() {
      return this.$store.state.app.scheme.event;
    }
  },
  created() {
    this.setDefaultValue();
  },
  watch: {
    value() {
      this.setDefaultValue();
    },
    date: function() {
      this.buttonPlaceholder = moment(dateUTC(this.date)).format(
        "MMM DD, YYYY"
      );
      this.showCalendar = !this.showCalendar;
      this.clicked = true;
      this.$emit("input", this.buttonPlaceholder);
    }
  },
  methods: {
    nm(date) {
      this.$emit("nm", date);
    },
    pm(date) {
      this.$emit("np", date);
    },
    ny(year) {
      this.$emit("ny", year);
    },
    py(year) {
      this.$emit("py", year);
    },
    setDefaultValue() {
      if (this.value && this.dropdownItems.length > 0) {
        const item = _.find(this.dropdownItems, { value: this.value });
        if (item) {
          this.buttonPlaceholder = item.name;
        } else {
          this.buttonPlaceholder = this.placeholder;
        }
      } else if (this.value) {
        this.buttonPlaceholder = this.value;
      } else {
        this.buttonPlaceholder = this.placeholder;
      }
    },
    handleDropDownToggleClick() {
      this.dropdownItems.length
        ? (this.showDropDown = !this.showDropDown)
        : (this.showCalendar = !this.showCalendar);
    },
    handleDropDownClose() {
      this.dropdownItems.length
        ? (this.showDropDown = false)
        : (this.showCalendar = false);
    },
    handleTabDropDownItemClick(key, name) {
      this.$emit("input", key);
      this.buttonPlaceholder = name;
      this.clicked = true;
      this.showDropDown = !this.showDropDown;
    }
  }
};
</script>

<style lang="scss">
.top {
  top: -350px !important;
}
.datepicker {
  display: flex;
  width: 260px;
  &-popup {
    border: none;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
  }
  .calendar {
    padding: 20px;
    width: 100%;
    &-next {
      &-year-btn {
        display: none;
      }
    }
    &-prev {
      &-month-btn {
        width: 34px;
      }
      &-year-btn {
        display: none;
      }
    }
    &-year-select {
      pointer-events: none;
      float: left;
    }
    &-month-select {
      pointer-events: none;
      float: left;
    }
    &-head a {
      font-size: 14px;
      font-weight: 400;
    }
    &-body {
      width: 100%;
      height: 100%;
    }
    &-days {
      a {
        color: #909090;
        padding: 5px;
      }
    }
    &-date {
      &:hover {
        border-radius: 90px;
        background: $brand-lighter;
      }
      &-selected {
        border-radius: 90px;
        color: white !important;
        /* background: $brand-primary; */
      }
      &-out {
        color: #dadada !important;
      }
      &-disabled {
        pointer-events: none !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "node_modules/bootstrap/scss/mixins/_breakpoints.scss";

.tabdropdown-trigger {
  background-color: transparent;
  border: 1px solid transparent;
  font-size: 0.875rem;
  padding: 8px 14px;
  width: 100%;
}
.tabdropdown-wrapper {
  border-radius: 10px;
  margin-top: 0.5rem;
  position: relative;
  .tabdropdown-list {
    background-color: $white;
    list-style-type: none;
    max-height: 210px;
    overflow: auto;
    opacity: 0;
    padding: 0;
    position: absolute;
    top: 0;
    min-width: 100%;
    visibility: hidden;
    z-index: 1069;
    border-radius: 5px;
    &.top {
      height: 210px;
      top: -280px !important;
    }
    &.show {
      opacity: 1;
      visibility: visible;
      padding: 10px;
    }
    .tabdropdown-item {
      color: $gray-700;
      cursor: pointer;
      font-size: 15px;
      margin: 0;
      padding: 10px 15px;
      transition: background-color 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
      &:hover {
        background-color: $gray-200;
      }
      &__disabled {
        background-color: #dcdcdc;
        color: #949494;
        pointer-events: none;
      }
    }
  }
  .calendar-wrapper {
    opacity: 0;
    position: absolute;
    top: 0;
    z-index: -1;
    &.show {
      opacity: 1;
      z-index: 5;
      transition: none !important;
    }
    a {
      font-family: $font-family-base;
      font-weight: 400;
    }
    .calendar-days {
      height: auto;
      a.calendar-date {
        border-radius: 50%;
        transition: all 0.2s ease;
        &:hover,
        &-selected {
          color: $white !important;
          background-color: $brand-primary;
        }
      }
    }
    .calendar-months,
    .calendar-year {
      a.calendar-date {
        transition: all 0.2s ease;
        &:hover,
        &-selected {
          color: $white !important;
          background-color: $brand-primary;
        }
      }
    }
  }
}
</style>
